/**
 * Testi italiani dei membri e degli inviti dei set (ADR 0032): pagina «Membri»,
 * invito, ruoli, inviti ricevuti nella campanella e nella Panoramica.
 */

/** Testi dei membri dei set. */
export const members = {
  /** Voce della barra laterale. */
  nav: 'Membri',
  /** Titolo della pagina. */
  title: 'Membri del set',
  /** Che cosa sono i membri. */
  description: 'Chi lavora in questo set e con quale ruolo.',

  /** Ruoli, come etichette. */
  roles: {
    /** Proprietario. */
    owner: 'Proprietario',
    /** Amministratore della piattaforma. */
    admin: 'Amministratore',
    /** Editor. */
    editor: 'Editor',
    /** Lettore. */
    viewer: 'Lettore',
  },
  /** Che cosa fa ciascun ruolo. */
  roleHelp: {
    /** Lettore. */
    viewer: 'Legge conversazione, attività, task e progetti. Non scrive.',
    /** Editor. */
    editor: 'Scrive all’Institore, gestisce i task e carica cartelle nei progetti.',
    /** Proprietario. */
    owner: 'Cambia impostazioni, agenti, progetti e membri.',
  },

  /** Il proprio ruolo nella testata del set. */
  yourRole: 'Il tuo ruolo: {{role}}',
  /** Avviso per i membri nelle sezioni del proprietario. */
  ownerOnly: 'Questa sezione la gestisce il proprietario del set. Puoi leggerla.',
  /** Avviso per i lettori nel relay. */
  readOnlyRelay: 'Sei lettore in questo set: puoi leggere la conversazione, non scrivere all’Institore.',

  /** Riquadri della pagina. */
  cards: {
    /** Persone del set. */
    people: 'Persone',
    /** Inviti in attesa. */
    invitations: 'Inviti in attesa',
  },
  /** Conteggio rispetto al limite del piano. */
  usage: '{{people}} persone su {{max}} ammesse dal piano, inviti compresi',
  /** Conteggio senza limite. */
  usageUnlimited: '{{people}} persone, inviti compresi',
  /** Nessun membro. */
  empty: 'Nessun membro oltre al proprietario.',
  /** Nessun invito. */
  noInvitations: 'Nessun invito in attesa.',
  /** Proprietario senza nome noto. */
  ownerUnknown: 'Proprietario del set',
  /** Ingresso. */
  joined: 'nel set dal {{date}}',
  /** Scadenza di un invito. */
  expires: 'scade il {{date}}',
  /** Invito scaduto. */
  expired: 'Scaduto',
  /** Lettura non riuscita. */
  loadFailed: 'Membri non caricati. Riprova.',

  /** Comandi. */
  actions: {
    /** Apre l'invito. */
    invite: 'Invita',
    /** Cambia ruolo, nome accessibile per riga. */
    roleOf: 'Ruolo di {{name}}',
    /** Toglie un membro. */
    remove: 'Togli',
    /** Toglie un membro, nome accessibile. */
    removeNamed: 'Togli {{name}}',
    /** Esce dal set. */
    leave: 'Esci dal set',
    /** Ritira un invito. */
    revoke: 'Ritira',
    /** Ritira un invito, nome accessibile. */
    revokeNamed: 'Ritira l’invito a {{name}}',
  },
  /** Conferme. */
  confirm: {
    /** Togliere un membro. */
    removeTitle: 'Togliere {{name}} dal set?',
    /** Conseguenza. */
    removeBody: '{{name}} perde subito l’accesso al set. I task assegnati restano.',
    /** Uscire. */
    leaveTitle: 'Uscire dal set?',
    /** Conseguenza dell'uscita. */
    leaveBody: 'Non vedrai più questo set. Per tornare serve un nuovo invito.',
    /** Ritirare un invito. */
    revokeTitle: 'Ritirare l’invito a {{name}}?',
    /** Conseguenza. */
    revokeBody: 'L’invito non si potrà più accettare.',
  },
  /** Esiti. */
  done: {
    /** Invito inviato. */
    invited: 'Invito inviato a {{name}}.',
    /** Ruolo cambiato. */
    roleChanged: 'Ruolo aggiornato.',
    /** Membro tolto. */
    removed: 'Membro tolto.',
    /** Uscito. */
    left: 'Sei uscito dal set.',
    /** Invito ritirato. */
    revoked: 'Invito ritirato.',
    /** Invito accettato. */
    accepted: 'Ora sei nel set {{name}}.',
    /** Invito rifiutato. */
    declined: 'Invito rifiutato.',
  },
  /** Errori con codice. */
  errors: {
    /** Nessun utente. */
    invitee_not_found: 'Nessun utente con questo nome. Controlla il nome utente: la persona deve essere entrata in institor almeno una volta.',
    /** Sé stessi. */
    cannot_invite_self: 'Non puoi invitare te stesso o il proprietario del set.',
    /** Già membro. */
    already_member: 'Questa persona è già membro del set.',
    /** Invito già presente. */
    invitation_pending: 'C’è già un invito in attesa per questa persona.',
    /** Limite del piano. */
    plan_limit_members: 'Il piano del proprietario non ammette altre persone in questo set. Togli un membro o ritira un invito.',
    /** Troppi inviti per l'invitato. */
    invitee_limit: 'Questa persona ha già troppi inviti in attesa. Riprova più tardi.',
    /** Invito chiuso. */
    invitation_closed: 'L’invito non è più valido: è scaduto o è stato ritirato.',
    /** Già proprietario. */
    already_owner: 'Sei già il proprietario di questo set.',
    /** Generico. */
    generic: 'Operazione non riuscita. Riprova.',
  },

  /** Cassetto dell'invito. */
  invite: {
    /** Titolo. */
    title: 'Invita nel set',
    /** Nome del modulo. */
    form: 'Invito nel set',
    /** Nome utente. */
    username: 'Nome utente',
    /** Aiuto. */
    usernameExtra: 'Il nome con cui la persona entra in institor. Non serve l’email.',
    /** Nome mancante. */
    usernameRequired: 'Scrivi il nome utente.',
    /** Ruolo. */
    role: 'Ruolo',
    /** Durata. */
    expiry: 'L’invito vale sette giorni. La persona lo vede nelle notifiche e lo accetta o lo rifiuta.',
    /** Invio. */
    submit: 'Invita',
    /** Avviso di sicurezza. */
    warning: 'Un editor scrive all’Institore del tuo set: i token che consuma contano sul tuo piano.',
  },

  /** Inviti ricevuti. */
  received: {
    /** Titolo del riquadro. */
    title: 'Inviti ricevuti',
    /** Una riga. */
    line: '{{who}} ti invita in {{set}} come {{role}}',
    /** Chi invita, se non noto. */
    someone: 'Il proprietario',
    /** Accetta. */
    accept: 'Accetta',
    /** Accetta, nome accessibile. */
    acceptNamed: 'Accetta l’invito a {{set}}',
    /** Rifiuta. */
    decline: 'Rifiuta',
    /** Rifiuta, nome accessibile. */
    declineNamed: 'Rifiuta l’invito a {{set}}',
    /** Scadenza. */
    expires: 'Scade il {{date}}.',
  },
};

/** Forma dei testi dei membri, usata per tipare le altre lingue. */
export type Members = typeof members;
